import { TextToDisplay } from "../../../pages/Execute/CarrierAssigned/shipmentPage.util";
import { IONICWrapper, isEntitled } from "../../../utils/common";
import { MODULES } from "../../../utils/constants";
import driverNames from "../../../utils/getDriverNameList";
import DriverNameFilter from "../../../web/components/driver-assign-filter/DriverNameFilter";
import { LoadsList } from "../../../web/components/loads-list";
import React, { useEffect, useState } from "react";
import { IonButton } from "@ionic/react";
import { myLoadShowMore, showMoreButtonVisiblityWithCount, FetchFromMyLoadConfig } from "../../../utils/MyLoads.util";

const DeliveredWithPPWKPage: React.FC<any> = (props: any) => {
  const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");
  const [chosed, setChosed] = useState({ name: "All Drivers", partyId: "All_Drivers" });


  const driverNameList: any = driverNames(
    props.driverList || []
  );
  const filterByDriver = (SelectedFilterOption: any) => {
    setChosed(SelectedFilterOption)
    props.paginatedLoads(0, SelectedFilterOption)
  };

  const showFilter = isEntitled("myLoad", "filter");

  return (
    <React.Fragment>
      {(showFilter && FetchFromMyLoadConfig("DriverFilterVisibility")) ? (
        <DriverNameFilter
          data={props?.loads || []}
          driverNameList={driverNameList}
          onSelect={filterByDriver}
          module={MODULES.DELIVERED_WITH_PPWK_MODULE}
          chosed={chosed}
        />
      ) : (
        <div className="carrier-load-count-title">
          {TextToDisplay(props?.loads, MODULES.DELIVERED_WITH_PPWK_MODULE)}
        </div>
        )}
      <LoadsList
        {...props}
        className={"myloads-list"}
        module={MODULES.DELIVERED_WITH_PPWK_MODULE}
        isCarrierLoad={true}
        loads={props?.loads}
      />
      {!props?.location?.state?.isGlobalSearch && showMoreButtonVisiblityWithCount(props?.getMyLoadsFilteredCount?.deliveredWithPaperWorkFilterCount ||props?.count?.deliveredWithPaperWorkCount, myLoadsMaxPageSize, props?.page) && props?.loads?.length > 0 ?
        <IonButton className="btn-common-web" onClick={() => props.paginatedLoads(props?.page + 1, chosed)}>
          Show {myLoadShowMore(myLoadsMaxPageSize, props?.loads?.length,props?.getMyLoadsFilteredCount?.deliveredWithPaperWorkFilterCount || props?.count?.deliveredWithPaperWorkCount)} More
     </IonButton> :
        <div className="list-end-banner">
          <div className="end-list">
            <div className="left"></div>
            <div className="center">End of list</div>
            <div className="right"></div>
          </div>
        </div>}
    </React.Fragment>
  );
};

export default DeliveredWithPPWKPage;
